import React from "react";

function WhyChooseUs() {
  return (
    <>
      {/* Features Start */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div
            className="section-title text-center position-relative pb-3 mb-5 mx-auto"
            style={{maxWidth: "600px"}}>
            <h5 className="fw-bold text-primary text-uppercase">Why Choose Us</h5>
            <h1 className="mb-0">We Are Here to Grow Your Business Exponentially</h1>
          </div>
          <div className="row g-5">
            <div className="col-lg-4">
              <div className="row g-5">
                <div className="col-12 wow zoomIn" data-wow-delay="0.2s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{width: "60px", height: "60px"}}>
                    <i className="fa fa-cubes text-white fs-2"></i>
                  </div>
                  <h4>Digital Expertise</h4>
                  <p className="mb-0">
                    Our confidence is due to experience, we can help you in all
                    aspects of Digital Marketing.
                  </p>
                </div>
                <div className="col-12 wow zoomIn" data-wow-delay="0.6s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{width: "60px", height: "60px"}}>
                    <i className="fa fa-award text-white fs-2"></i>
                  </div>
                  <h4>Measurable Results</h4>
                  <p className="mb-0">
                    We know 'Digital Marketing' and we let the results speak about
                    our knowledge.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 wow zoomIn"
              data-wow-delay="0.9s"
              style={{minHeight: "350px"}}>
              <div className="position-relative h-100">
                <img
                  className="position-absolute w-100 h-100 rounded wow zoomIn"
                  data-wow-delay="0.1s"
                  src="/img/why choose us (340 x 370).jpg"
                  style={{objectFit: "cover"}}
                  alt="Why Choose Us"
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="row g-5">
                <div className="col-12 wow zoomIn" data-wow-delay="0.4s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{width: "60px", height: "60px"}}>
                    <i className="fa fa-users-cog text-white fs-2"></i>
                  </div>
                  <h4>Tailored Strategies</h4>
                  <p className="mb-0">
                    No matter how big or small your business is, we offer tailored
                    solutions to meet your goals and budget.
                  </p>
                </div>
                <div className="col-12 wow zoomIn" data-wow-delay="0.8s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{width: "60px", height: "60px"}}>
                    <i className="fa fa-phone-alt text-white fs-2"></i>
                  </div>
                  <h4>24 x 7 Support</h4>
                  <p className="mb-0">
                    Please feel free to reach out to us, our professional staff is
                    ready to assist you.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Features End */}
    </>
  );
}

export default WhyChooseUs;
